import { template } from 'lodash';

export const tagTemplate = s => {
  return template(s, {
    interpolate: /{{([\s\S]+?)}}/g,
  });
};

/*
  svg file no in chinese
 */
export const svgFor = (svg, fill) => {
  return `data:image/svg+xml;base64,${window.btoa(
    unescape(encodeURIComponent(tagTemplate(svg)(fill))),
  )}`;
};
